import {
  LTAnchoredOverlay,
  LTDivider,
  LTIconButton,
  LTInputBox,
} from '@lambdatestincprivate/lt-components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from 'components/Icons/new-theme';
import CopyToClipboard from 'react-copy-to-clipboard';

import './style.css';
import LTText from 'components/LTComponents/LTText/LTText';

const CopyButton = ({ ariaLabel, text }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  const iconName = isCopied ? 'check-bold' : 'copy-icon';
  return (
    <CopyToClipboard text={text}>
      <LTIconButton
        onClick={handleCopy}
        aria-label={ariaLabel}
        className="lt-icon-button-input"
        icon={() => <Icon name={iconName} />}
      />
    </CopyToClipboard>
  );
};

const AnchoredOverlay = ({ renderOnlyInnerContent = false, children }) => {
  if (renderOnlyInnerContent) {
    return children;
  }

  return (
    <LTAnchoredOverlay
      ariaLabel="Access Key"
      iconComponent={() => <Icon name="accesskey" />}
    >
      {children}
    </LTAnchoredOverlay>
  );
};

const AccessKeyPopup = ({ renderOnlyInnerContent }) => {
  const { username, apiToken } = useSelector(
    (state) => state?.userInfo?.userInfo?.data
  );

  return (
    <AnchoredOverlay renderOnlyInnerContent={renderOnlyInnerContent}>
      <div className="lt-accesskey-container">
        <span className="lt-accesskey-title">Credentials</span>
        <LTDivider />
        <div className="lt-accesskey-section-wrapper">
          <div className="lt-accesskey-section">
            <LTText weight={600} size={12} lineHeight={18} text="Username" />
            <div className="lt-accesskey-value-section">
              <LTInputBox
                ariaLabel="Username"
                autoCompleteType="off"
                className="lt-text-input"
                disabled={true}
                leadingIcon=""
                name="Username"
                size={LTInputBox.Size.MEDIUM}
                value={username}
              />

              <CopyButton ariaLabel="Copy user" text={username} />
            </div>
          </div>
          <div className="lt-accesskey-section">
            <LTText weight={600} size={12} lineHeight={18} text="Access Key" />
            <div className="lt-accesskey-value-section">
              <LTInputBox
                ariaLabel="Access Key"
                autoCompleteType="off"
                className="lt-text-input"
                disabled={true}
                leadingIcon=""
                name="Access Key"
                size={LTInputBox.Size.MEDIUM}
                value={'**********'}
              />
              <CopyButton ariaLabel="Copy access key" text={apiToken} />
            </div>
          </div>
        </div>
      </div>
    </AnchoredOverlay>
  );
};

export default AccessKeyPopup;
